import React from "react";

export const LoadingOverlay: React.FC = () => (
    <div className="rd-overlay">
        <div className="rd-overlay__spinner" role="status" aria-label="Загрузка" />
    </div>
);
